import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import { fetch } from '../../actions'
import { useFetchPostV2, useSavePost, useSavePostClick } from '../../components/Hooks/Conexao'
import Mensagens from '../../components/Mensagens';
import Menu from '../Shared/Menu'
import { Button, Icon, Tabs, Input } from 'antd';
import ModalDetalhe from '../../components/ModalDetalhe';
import Spinner from '../../components/Spinner/Spinner';
import { SubTitulo, LoadingScreen } from '../../components/Diversos';
import PesquisaSelect from '../../components/PesquisaSelect';
import { BtnConfirm } from './../../components/Diversos';

const TabPane = Tabs.TabPane;
const { TextArea } = Input;

function ContDet({ dados, fetch, onSave }) {
    const [pesqEmp, setPesqEmp] = useState([]);
    const [dadosEditing, setDadosEditing] = useState(!dados.id);
    const [dadosNome, setDadosNome] = useState(dados.nome);
    const [dadosEmail, setDadosEmail] = useState(dados.email);
    const [dadosSenha, setDadosSenha] = useState('');
    const [dadosObs, setDadosObs] = useState(dados.obs);
    const [empresas, setEmpresas] = useState(dados.empresas);

    const [saveDados, savingDados] = useSavePost(fetch, '/contador/save', {
        modelo: 'contador', dados: {
            id: dados.id,
            nome: dadosNome,
            email: dadosEmail,
            senha: dadosSenha,
            obs: dadosObs
        }
    },
        () => {
            Mensagens.showSucesso('Gravado com sucesso!');
            onSave();
        });

    const [saveEmpresa, savingEmpresa] = useSavePost(fetch, '/contador/save', { modelo: 'add-empresa', dados: { id: dados.id, empresa: pesqEmp } },
        (dados) => {
            Mensagens.showSucesso('Gravado com sucesso!');
            let emps = [...empresas, dados];
            setEmpresas(emps);
            setPesqEmp([]);
        });

    const [delEmpresa, deletingEmpresa] = useSavePostClick(fetch, '/contador/save',
        (idExcluido) => {
            Mensagens.showSucesso('Excluído com sucesso!');
            let emps = [...empresas];
            const inx = emps.findIndex(x => x.id == idExcluido);
            emps.splice(inx, 1);
            setEmpresas(emps);
        });


    return (
        <>
            <LoadingScreen loading={savingDados || savingEmpresa || deletingEmpresa} />
            <Tabs defaultActiveKey="1">
                <TabPane tab="Dados" key="1" style={{ minHeight: 300 }}>
                    <div style={{ textAlign: 'right' }}>
                        {dadosEditing && (<Button type="primary" shape="circle" onClick={() => saveDados()} style={{ marginRight: 7 }}><Icon type="save" /></Button>)}
                        <Button type="default" shape="circle" onClick={() => setDadosEditing(true)} disabled={dadosEditing}><Icon type="edit" /></Button>
                    </div>
                    <div>
                        <SubTitulo>Nome</SubTitulo>
                        <Input value={dadosNome} onChange={e => setDadosNome(e.target.value)} disabled={!dadosEditing} />
                        <SubTitulo style={{ marginTop: 10 }}>Email</SubTitulo>
                        <Input value={dadosEmail} onChange={e => setDadosEmail(e.target.value)} disabled={!dadosEditing} />
                        {!dados.id && (<>
                            <SubTitulo style={{ marginTop: 10 }}>Senha</SubTitulo>
                            <Input value={dadosSenha} onChange={e => setDadosSenha(e.target.value)} disabled={!dadosEditing} />
                        </>)}
                        <div style={{ marginTop: 10 }}>
                            <SubTitulo>Observações</SubTitulo>
                            <TextArea rows={5} value={dadosObs} onChange={e => setDadosObs(e.target.value)} disabled={!dadosEditing} />
                        </div>
                    </div>
                </TabPane>
                {dados.id && (
                    <TabPane tab="Empresas" key="2">
                        <div>
                            <div style={{ marginBottom: 15 }}>
                                <PesquisaSelect modelo='empresas' handleChange={setPesqEmp} dados={pesqEmp} style={{ maxWidth: 400, marginRight: 10 }} />
                                <Button onClick={() => saveEmpresa()} shape="circle" type="primary" ghost style={{ marginRight: 5 }} disabled={!pesqEmp || pesqEmp.length != 1}> <Icon type="plus" /> </Button>
                            </div>
                            <table className="tabela-padrao">
                                <thead>
                                    <tr>
                                        <th className="text-left">Nome</th>
                                        <th className="text-right"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(empresas || []).map(e => {
                                        return (
                                            <tr key={e.id}>
                                                <td className="text-left">{e.nome ? e.nome : 'NOVO CADASTRO'}</td>
                                                <td className="text-right"><BtnConfirm type="link" size="small" onClick={() => delEmpresa({ modelo: 'del-empresa', dados: { id: dados.id, idEmp: e.id } })}>Excluir</BtnConfirm></td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                        {/* <pre>{JSON.stringify(empresas, null, 2)}</pre> */}
                    </TabPane>
                )}
            </Tabs>
        </>
    )
}

function Func(props) {
    const [dados, listar, loading, setDados] = useFetchPostV2(props.fetch, '/contador', { modelo: 'contador', dados: {} })
    const [detId, setDetId] = useState(null);

    useEffect(() => {
        listar();
    }, []);

    return (
        <>
            <Menu />
            <div style={{ textAlign: 'center', marginTop: 15 }}><h2>Contadores</h2></div>

            <div> <Button type="primary" shape="circle" onClick={() => setDetId(0)}><Icon type="plus" /></Button></div>

            {loading && <div style={{ marginTop: 40 }}><Spinner /></div>}
            {!loading && dados && (<div className="tabela-wrapper">
                <table className="tabela-padrao">
                    <thead>
                        <tr>
                            <th className="text-left">Nome</th>
                            <th className="text-left">Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(dados || []).map(v => {
                            return (
                                <tr key={v.id} style={{ cursor: 'pointer' }} onClick={() => setDetId(v.id)}>
                                    <td className="text-left">{v.nome ? v.nome : 'NOVO CADASTRO'}</td>
                                    <td className="text-left">{v.email}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            )}

            <ModalDetalhe
                WrappedDet={ContDet}
                url='contador'
                modelo='contador-det'
                id={detId}
                onCancel={() => setDetId(null)}
                onSave={() => { setDetId(null); listar(); }}
                width={800}
            />
        </>
    )
}

export default connect(null, { fetch })(Func);